import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionOngoingPurchasePremiumSelect } from "../ongoing-purchase/actionOngoingPurchase";
import { actionSpendGoldConfirmationFinish, TypeActionSpendGoldConfirmation, } from "./actionSpendGoldConfirmation";
export var epicSpendGoldConfirmation = function (action$) {
    return action$.pipe(ofType(TypeActionSpendGoldConfirmation.Receive), switchMap(function (action) {
        var premiumInfo = {
            isConfirmed: action.status,
        };
        return from([
            actionOngoingPurchasePremiumSelect(premiumInfo),
            actionSpendGoldConfirmationFinish(),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/spend-gold-confirmation/epicSpendGoldConfirmation.ts
// module id = 2414
// module chunks = 3